import { render, staticRenderFns } from "./OlympicsRegistrationForm.vue?vue&type=template&id=37105bfc&scoped=true"
import script from "./OlympicsRegistrationForm.vue?vue&type=script&lang=js"
export * from "./OlympicsRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./OlympicsRegistrationForm.vue?vue&type=style&index=0&id=37105bfc&prod&scoped=true&lang=scss"
import style1 from "./OlympicsRegistrationForm.vue?vue&type=style&index=1&id=37105bfc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37105bfc",
  null
  
)

export default component.exports